<template>
  <div>
    <b-alert
      :show="!isDocumentValid"
      dismissible
      variant="danger"
    >
      ATENÇÃO! Documento inválido.
    </b-alert>
  </div>
</template>

<script>
export default {
  name: 'InvalidDocumentAlert',
  props: {
    personDocument: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      isDocumentValid: false
    }
  },
  mounted () {
    if (this.personDocument !== null) this.isValidDocument(this.personDocument)
  },
  watch: {
    personDocument (newPersonDocument, oldPersonDocument) {
      this.isValidDocument(newPersonDocument)
    }
  },
  methods: {
    isValidDocument (documento) {
      documento = documento.replace(/[^\d]+/g, '')
      if (documento.length === 11) {
        this.isDocumentValid = this.isValidCpf(documento)
      } else if (documento.length === 14) {
        this.isDocumentValid = this.isValidCnpj(documento)
      }
    },
    isValidCpf (cpf) {
      cpf = cpf.replace(/[^\d]+/g, '')
      if (cpf === '') return false
      if (
        cpf.length !== 11 ||
        cpf === '00000000000' ||
        cpf === '11111111111' ||
        cpf === '22222222222' ||
        cpf === '33333333333' ||
        cpf === '44444444444' ||
        cpf === '55555555555' ||
        cpf === '66666666666' ||
        cpf === '77777777777' ||
        cpf === '88888888888' ||
        cpf === '99999999999'
      ) {
        return false
      }
      let add = 0
      for (let i = 0; i < 9; i++) {
        add += parseInt(cpf.charAt(i)) * (10 - i)
      }
      let rev = 11 - (add % 11)
      if (rev === 10 || rev === 11) {
        rev = 0
      }
      if (rev !== parseInt(cpf.charAt(9))) {
        return false
      }
      add = 0
      for (let i = 0; i < 10; i++) {
        add += parseInt(cpf.charAt(i)) * (11 - i)
      }
      rev = 11 - (add % 11)
      if (rev === 10 || rev === 11) {
        rev = 0
      }
      return rev === parseInt(cpf.charAt(10))
    },
    isValidCnpj (document) {
      if (document === null || document.length !== 14) {
        return false
      }
      if (
        document === '00000000000000' ||
        document === '11111111111111' ||
        document === '22222222222222' ||
        document === '33333333333333' ||
        document === '44444444444444' ||
        document === '55555555555555' ||
        document === '66666666666666' ||
        document === '77777777777777' ||
        document === '88888888888888' ||
        document === '99999999999999'
      ) {
        return false
      }

      // Valida DVs
      let tamanho = document.length - 2
      let numeros = document.substring(0, tamanho)
      let digitos = document.substring(tamanho)
      let soma = 0
      let pos = tamanho - 7
      for (let i = tamanho; i >= 1; i--) {
        soma += parseInt(numeros.charAt(tamanho - i)) * pos--
        if (pos < 2) {
          pos = 9
        }
      }
      let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11)
      if (resultado !== parseInt(digitos.charAt(0))) {
        return false
      }

      tamanho = tamanho + 1
      numeros = document.substring(0, tamanho)
      soma = 0
      pos = tamanho - 7
      for (let i = tamanho; i >= 1; i--) {
        soma += parseInt(numeros.charAt(tamanho - i)) * pos--
        if (pos < 2) {
          pos = 9
        }
      }
      resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11)
      return resultado === parseInt(digitos.charAt(1))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/UI/invalid-document-alert/InvalidDocumentAlert.vue